"use strict";

var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.KameleoonClient = void 0;
var _javascriptSdkCore = require("@kameleoon/javascript-sdk-core"),
  _requester = require("./requester"),
  _storage = require("./storage"),
  _eventSource = require("./eventSource"),
  _visitorCodeManager = require("./visitorCodeManager"),
  _prng = require("./prng"),
  _defaultLogger = require("./defaultLogger");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    _defineProperty(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var KameleoonClient = /*#__PURE__*/function (_javascriptSdkCore$Ka) {
  function KameleoonClient(a) {
    var _this;
    _classCallCheck(this, KameleoonClient);
    var b = a.siteCode,
      c = a.configuration,
      d = a.externals,
      e = a._internals;
    var f = (null === e || void 0 === e ? void 0 : e.prng) || new _prng.KameleoonPRNG(),
      g = (null === d || void 0 === d ? void 0 : d.storage) || new _storage.DataStorage(),
      h = (null === d || void 0 === d ? void 0 : d.requester) || new _requester.Requester(),
      i = (null === d || void 0 === d ? void 0 : d.eventSource) || new _eventSource.KameleoonEventSource(),
      j = new _javascriptSdkCore.VisitorCodeManager(),
      k = (null === d || void 0 === d ? void 0 : d.visitorCodeManager) || new _visitorCodeManager.KameleoonVisitorCodeManager(),
      l = (null === e || void 0 === e ? void 0 : e.packageInfo) || {
        type: _javascriptSdkCore.SdkLanguageType.JAVASCRIPT,
        version: "4.4.0",
        isServer: !1
      },
      m = {
        externalPRNG: f,
        externalStorage: g,
        externalRequester: h,
        externalEventSource: i,
        externalVisitorCodeManager: j,
        externalPackageInfo: l,
        externalLogger: (null === d || void 0 === d ? void 0 : d.logger) || new _defaultLogger.DefaultLogger()
      };
    _this = _callSuper(this, KameleoonClient, [{
      siteCode: b,
      configuration: c,
      internalConfiguration: {
        externals: m,
        settings: {
          useAbortController: !0
        }
      }
    }]), _defineProperty(_assertThisInitialized(_this), "domain", void 0), _defineProperty(_assertThisInitialized(_this), "internalVisitorCodeManager", void 0), _defineProperty(_assertThisInitialized(_this), "externalVisitorCodeManager", void 0);
    var n = _javascriptSdkCore.Validator.validateDomain(null === c || void 0 === c ? void 0 : c.cookieDomain);
    _this.domain = n.ok ? n.data : void 0, _this.internalVisitorCodeManager = j, _this.externalVisitorCodeManager = k;
    return _this;
  }
  _inherits(KameleoonClient, _javascriptSdkCore$Ka);
  return _createClass(KameleoonClient, [{
    key: "getVisitorCode",
    value: function getVisitorCode(a) {
      var _this2 = this;
      _javascriptSdkCore.KameleoonLogger.info(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL KamaleoonClient.getVisitorCode(defaultVisitorCode: ", ")"])), a), this.internalVisitorCodeManager.getData = function (a) {
        return _this2.externalVisitorCodeManager.getData(a);
      }, this.internalVisitorCodeManager.setData = function (a) {
        _this2.externalVisitorCodeManager.setData(_objectSpread(_objectSpread({}, a), {}, {
          domain: _this2.domain
        }));
      };
      var b = this.internalVisitorCodeManager.getVisitorCode(a);
      return _javascriptSdkCore.KameleoonLogger.info(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN KamaleoonClient.getVisitorCode(defaultVisitorCode: ", ") -> (visitorCode: ", ")"])), a, b), b;
    }
  }, {
    key: "setLegalConsent",
    value: function setLegalConsent(a, b) {
      var _this3 = this;
      _superPropGet(KameleoonClient, "setUserConsent", this, 3)([{
        visitorCode: a,
        consent: b,
        setData: function setData(a) {
          _this3.externalVisitorCodeManager.setData(_objectSpread(_objectSpread({}, a), {}, {
            domain: _this3.domain
          }));
        }
      }]);
    }
  }]);
}(_javascriptSdkCore.KameleoonCore);
exports.KameleoonClient = KameleoonClient;